<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="名称" prop="applicationTitle">
        <Input v-model="form.applicationTitle" :maxlength="64"></Input>
      </FormItem>
<!--       <FormItem label="应用类型" prop="appSystem">
        <sl-select dict="$appSystem" value-type="string" v-model="form.appSystem" />
      </FormItem> -->
      <FormItem label="平台类型" prop="terminal">
        <sl-select dict="$appPlatform" type="radio" v-model="form.terminal" />
      </FormItem>
      <FormItem label="版本号" prop="versionNo">
        <Input v-model="form.versionNo" :maxlength="128"></Input>
      </FormItem>
      <FormItem label="强制更新" prop="isRequired">
        <sl-select dict="$NY" type="radio" v-model="form.isRequired" />
      </FormItem>
      <FormItem label="立即发布" prop="isVisible">
        <sl-select dict="$NY" type="radio" v-model="form.isVisible" />
      </FormItem>
      <FormItem label="更新说明" prop="description">
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.description"></Input>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.remark"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        terminal: [
          { type: 'number', required: true, message: '请选择平台类型', trigger: 'blur,change' },
        ],
        appSystem: [
          { type: 'number', required: true, message: '请选择应用类型', trigger: 'blur,change' },
        ],
        applicationTitle: [
          { required: true, message: '请填写名称', trigger: 'blur,change' },
        ],
        versionNo: [
          { required: true, message: '请填写版本号', trigger: 'blur,change' },
        ],
        isRequired: [
          { type: 'number', required: true, message: '请选择更新类型', trigger: 'blur,change' },
        ],
        description: [
          { required: true, message: '请填写更新说明', trigger: 'blur,change' },
        ],
      },
      def: {},
      form: {
        id: null,
        applicationTitle: null,
        terminal: null,
        appSystem:null,
        versionNo: null,
        isRequired: null,
        description: null,
        isVisible:1,
        remark: null,
      },
      id: null,
      loading: false,
      isCreate: true,
      modalVisible: false,
    }
  },

  computed: {
    itemTitle() {
      return this.id ? '编辑版本' : '新增版本'
    }
  },
  created() {
    this.def = { ...this.form }
  },

  methods: {

    init(id) {
      this.id = id
      this.reset()
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.appVer(this.id).then(resp => {
        this.$utils.fill(this.form, resp.data)
      })

    },

    reset() {
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
    },

    save() {
      //
      let params = { ...this.form }

      this.loading = true
      let promise = this.id ? this.$request.appVerUpdate : this.$request.appVerCreate
      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')

          //if( !this.id ){
            this.modalVisible = false
          //}
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    }
  }
}

</script>